import MODULE_NAMES from 'App/config/moduleNames';
import DocumentationIcon from 'connect-icons/Documentation';
import GhostwriterIcon from 'connect-icons/Ghostwriter';
import MeteringPoint from 'connect-icons/MeteringPoint';
import { defineMessage } from 'react-intl';

export const Documentation = {
  path: 'https://docs.utilihive.io',
  intlMessage: defineMessage({ id: 'route.documentation', defaultMessage: 'Documentation' }),
  Icon: <DocumentationIcon />,
};

export const ghostwriter = {
  path: '/ghostwriter',
  intlMessage: defineMessage({ id: 'route.ghostwriter', defaultMessage: 'Ghostwriter' }),
  Icon: <GhostwriterIcon />,
  moduleNameForOrganisationAccess: MODULE_NAMES.GHOSTWRITER,
  external: true,
};

export const assets = {
  path: '/assets',
  intlMessage: defineMessage({ id: 'route.assets', defaultMessage: 'Assets' }),
  Icon: <MeteringPoint />,
  moduleNameForOrganisationAccess: MODULE_NAMES.ASSETS,
  external: true,
};
